// Utility functions for exporting data to CSV

// Convert data to CSV format
export const convertToCSV = <T>(data: T[], columns: { header: string; accessor: string }[]): string => {
  if (!data || data.length === 0) return '';

  // Extract headers from columns
  const headers = columns.map((col) => col.header).join(',');

  // Extract rows
  const rows = data
    .map((row: any) => {
      return columns
        .map((col) => {
          const accessor = col.accessor;
          let value = row[accessor];

          // Handle nested objects
          if (typeof value === 'object' && value !== null) {
            value = JSON.stringify(value);
          }

          // Escape commas and quotes
          if (value === null || value === undefined) {
            return '';
          }

          value = String(value);
          if (value.includes(',') || value.includes('"') || value.includes('\n')) {
            value = `"${value.replace(/"/g, '""')}"`;
          }

          return value;
        })
        .join(',');
    })
    .join('\n');

  return `${headers}\n${rows}`;
};

// Download CSV file
export const downloadCSV = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

// Export candidates to CSV
export const exportCandidatesToCSV = (candidates: any[]): void => {
  const columns = [
    { header: 'Candidate Name', accessor: 'name' },
    { header: 'Job Title', accessor: 'jobTitle' },
    { header: 'Hired Date', accessor: 'hiredDate' },
    { header: 'Hired Month', accessor: 'hiredMonth' },
    { header: 'POC Name', accessor: 'pocName' },
    { header: 'Fee Amount', accessor: 'feeAmount' },
  ];

  const csv = convertToCSV(candidates, columns);
  const filename = `hired_candidates_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csv, filename);
};

// Export invoices to CSV
export const exportInvoicesToCSV = (invoices: any[]): void => {
  const columns = [
    { header: 'Invoice Number', accessor: 'invoiceNumber' },
    { header: 'Month', accessor: 'month' },
    { header: 'Generated Date', accessor: 'generatedDate' },
    { header: 'Due Date', accessor: 'dueDate' },
    { header: 'Candidates Count', accessor: 'candidateCount' },
    { header: 'Total Amount', accessor: 'totalAmount' },
    { header: 'Status', accessor: 'status' },
    { header: 'Paid Date', accessor: 'paidDate' },
  ];

  const csv = convertToCSV(invoices, columns);
  const filename = `invoices_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csv, filename);
};
